<div class="modal-header" *ngIf="title">
  <h5 class="modal-title">{{ title }}</h5>
</div>

<div class="modal-body">
  <ng-template #host></ng-template>
</div>
